<template>
  <div>
    <el-carousel :interval="5000" :arrow="imgList.length >1 ? 'always' : 'never'" height="420px" :autoplay="false" trigger="click">
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <div style="height:100%; ">
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions">
          </video-player>
          <!-- <video v-if="isVideo(item)" style="width: 100%;height: 100%;" :src="item" controls></video>
          <el-image :src="item" fit="contain" style="height: 100%;display: flex; justify-content: center;" v-else></el-image> -->
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    imgList(ov, nv) {
      console.log(ov);
    }
  },
  computed: {
    playerOptions() {
      const playerOptionsObj = {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: this.imgList[0],
          },
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      };
      return playerOptionsObj;
    },
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  methods: {
    isVideo(str) {
      return str.search('mp4') != -1 || str.search('avi') != -1;
    }
  }
};
</script>

<style lang="stylus" scoped>
// .el-carousel__item h3 {
//   color: #475669;
//   font-size: 18px;
//   opacity: 0.75;
//   line-height: 300px;
//   margin: 0;
// }

// .el-carousel__item:nth-child(2n) {
//   background-color: #99a9bf;
// }

// .el-carousel__item:nth-child(2n+1) {
//   background-color: #d3dce6;
// }

>>> .video-player {
  height: 100%;
}

>>> .video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3 {
  height: 100%;
  padding-top: 0 !important;
}

</style>
